import type { LanguageCode } from '../game/types'
import { UI_MESSAGES, type MessageKey } from './messages'

export function translateStatic(
  lang: LanguageCode,
  key: MessageKey,
  params?: Record<string, string | number>,
): string {
  const dict = UI_MESSAGES[lang]
  const fallback = UI_MESSAGES.en
  let s = dict[key] ?? fallback[key] ?? String(key)
  if (params) {
    s = s.replace(/\{\{(\w+)\}\}/g, (_, k: string) =>
      String(params[k] ?? ''),
    )
  }
  return s
}
